let prevTarget;
let shouldClickRemove = true;
export function initCategoryNav() {
    const jsCategories = document.getElementsByClassName('jsCategory');
    const mobileTest = document.querySelector('[data-mobile-test]');
    const computedStyle = window.getComputedStyle(mobileTest, null);
    if (computedStyle.display !== 'none') {
        return;
    }
    Array.from(jsCategories).forEach(function (element) {
        element === null || element === void 0 ? void 0 : element.addEventListener('click', (event) => {
            event.preventDefault();
            const target = event.target;
            const elem = target.nextElementSibling;
            if (!target.dataset.href) {
                event.preventDefault();
            }
            const navBar = document.getElementById('nav-bar');
            if (navBar.children[3] !== undefined) {
                if (!target.classList.contains('jsCategory') || prevTarget === target) {
                    return;
                }
            }
            const clonedEl = elem.cloneNode(true);
            clonedEl.style.display = 'block';
            clonedEl.style.left = '50%';
            clonedEl.style.transform = 'translateX(-50%)';
            clonedEl.style.width = '100%';
            clonedEl.style.maxWidth = '1280px';
            navBar === null || navBar === void 0 ? void 0 : navBar.appendChild(clonedEl);
            requestAnimationFrame(function () {
                adjustArrow(target, clonedEl);
            });
            prevTarget = target;
            document === null || document === void 0 ? void 0 : document.addEventListener('click', function removeChild(event) {
                if (!element.contains(event.target)) {
                    if (navBar.children[3] !== undefined && shouldClickRemove) {
                        navBar === null || navBar === void 0 ? void 0 : navBar.removeChild(navBar.children[3]);
                    }
                    shouldClickRemove = true;
                    this.removeEventListener('click', removeChild);
                }
            });
            window === null || window === void 0 ? void 0 : window.addEventListener('resize', function removeOnResize() {
                if (navBar.children[3] !== undefined) {
                    navBar === null || navBar === void 0 ? void 0 : navBar.removeChild(navBar.children[3]);
                    shouldClickRemove = false;
                }
                prevTarget = null;
                this.removeEventListener('resize', removeOnResize);
            });
            document === null || document === void 0 ? void 0 : document.addEventListener('scroll', function removeOnScroll() {
                if (navBar.children[3] !== undefined) {
                    navBar === null || navBar === void 0 ? void 0 : navBar.removeChild(navBar.children[3]);
                    shouldClickRemove = false;
                }
                this.removeEventListener('scroll', removeOnScroll);
            });
        });
    });
    const rightArrowNav = document.getElementById('right-arrow-nav');
    const leftArrowNav = document.getElementById('left-arrow-nav');
    const nav = document.getElementById('sub-nav');
    const scrollAmount = () => Math.max(250, nav.clientWidth * 0.5);
    rightArrowNav === null || rightArrowNav === void 0 ? void 0 : rightArrowNav.addEventListener('click', function () {
        nav.scrollBy({
            left: scrollAmount(),
            behavior: 'smooth'
        });
    });
    leftArrowNav === null || leftArrowNav === void 0 ? void 0 : leftArrowNav.addEventListener('click', function () {
        nav.scrollBy({
            left: -scrollAmount(),
            behavior: 'smooth'
        });
    });
    function updateArrows() {
        if (!nav)
            return;
        leftArrowNav.style.visibility = nav.scrollLeft > 0 ? 'visible' : 'hidden';
        rightArrowNav.style.visibility = nav.scrollLeft < (nav.scrollWidth - nav.clientWidth) ? 'visible' : 'hidden';
    }
    updateArrows();
    nav === null || nav === void 0 ? void 0 : nav.addEventListener('scroll', updateArrows);
}
function adjustArrow(triggerElement, subMenu) {
    const triggerRect = triggerElement.getBoundingClientRect();
    const triggerCenter = triggerRect.left + (triggerRect.width / 2);
    const subMenuRect = subMenu.getBoundingClientRect();
    const arrowLeft = triggerCenter - subMenuRect.left;
    subMenu.style.setProperty('--arrow-left', `${arrowLeft}px`);
}
